import React from "react";
import { Col } from "react-bootstrap";
import { Controller } from "react-hook-form";
import _ from "lodash";
import { NumericFormat, PatternFormat } from "react-number-format";
import ShamsiDatePicker from "../../_Components/ShamsiDatePicker";
import { TextField } from "@mui/material";

function MobileViewOfWaranty({ control, errors, item, showPrice, inputOnChange, inputList, setValue }) {
  function inputOnChange(event, name) {
    let inputType = "BIP_";
    if (name.includes("BIPD_")) inputType = "BIPD_";
    if (name.includes("BIPT_")) inputType = "BIPT_";
    let currentInput = inputList.filter(function (item) {
      return item.id == name.replace(inputType, "");
    });
    let currentInputId = currentInput[0] && currentInput[0].id;
    let currentGroupList = inputList.filter(function (item) {
      return item.basketItemId == currentInput[0].basketItemId;
    });

    (inputType == "BIP_" ? currentGroupList : inputList).map((item) => {
      if (
        (inputType == "BIP_" ? currentGroupList : inputList).id != item.id &&
        (item.priceIsLock || inputType != "BIP_") &&
        (item.dateIsLock || inputType != "BIPD_") &&
        (item.timeIsLock || inputType != "BIPT_") &&
        (inputType == "BIP_" ? currentGroupList : inputList)[0].id == currentInputId
      ) {
        if (inputType == "BIPD_") {
          setValue("BIPD_" + item.id, event);
        } else {
          setValue(inputType + item.id, event.target.value);
        }
      } else if (
        (inputType == "BIP_" ? currentGroupList : inputList).id != name.replace(inputType, "") &&
        item.id == currentInputId
      ) {
        if (inputType == "BIP_") {
          item.priceIsLock = false;
        }
        if (inputType == "BIPD_") item.dateIsLock = false;
        if (inputType == "BIPT_") item.timeIsLock = false;
      } else if ((inputType == "BIP_" ? currentGroupList : inputList)[0].id != currentInputId) {
        if (inputType == "BIPD_") {
          setValue(inputType + currentInputId, event);
        } else {
          setValue(inputType + currentInputId, event.target.value);
        }
      }
    });
  }

  return (
    <>
      <Col>
        <Col className="d-flex justify-content-end my-2">
          <span>{item?.personFullName}</span>
        </Col>
        <Col className="d-flex justify-content-end my-2">
          <span>{`${showPrice.format(item?.price)}تومان`}</span>
        </Col>
        <Col className="d-flex justify-content-end my-2">
          <span>{`${showPrice.format(item?.price)}تومان`}</span>
        </Col>
        <Col className="px-0 d-flex justify-content-end my-2">
          <Controller
            name={"BIP_" + item?.id}
            control={control}
            rules={{ required: true }}
            render={({ field: { onChange, value } }) => {
              const isAgent = item.basketCreatorType === 1;
              return (
                <NumericFormat
                  customInput={TextField}
                  name={"BIP_" + item?.id}
                  size="small"
                  value={value || ""}
                  className={
                    errors["BIP_" + item?.id]
                      ? "border border-danger form-control text-center"
                      : "text-center form-control"
                  }
                  variant="outlined"
                  thousandSeparator=","
                  decimalScale="."
                  onChange={(event) => inputOnChange(event, "BIP_" + item?.id)}
                  placeholder="مبلغ "
                  disabled={isAgent}
                  type="search"
                  title={
                    isAgent
                      ? "این بلیط توسط نماینده ثبت شده و کمیسیون ویژه دارد؛ تغییر مبلغ امکان‌پذیر نیست."
                      : ""
                  }
                  onKeyDown={(e) => {
                    if (e.key === "Escape") {
                      e.stopPropagation()
                    }
                  }}
                />
              );
            }}
          />
        </Col>
        <Col className="px-0 d-flex justify-content-end my-2">
          <Controller
            name={"BIPD_" + item?.id}
            control={control}
            render={({ field: { onChange, value } }) => (
              <ShamsiDatePicker value={value} onChange={onChange} placeholder="تاریخ" />
            )}
          />
        </Col>
        <Col className="px-0 d-flex justify-content-end my-2">
          <Controller
            name={"BIPT_" + item?.id}
            rules={{ required: true }}
            control={control}
            render={({ field: { onChange, value } }) => (
              <PatternFormat
                customInput={TextField}
                format="##:##"
                type="search"
                onKeyDown={(e) => {
                  if (e.key === "Escape") {
                    e.stopPropagation()
                  }
                }}
                name={"BIPT_" + item?.id}
                value={value || ""}
                onChange={(event) => inputOnChange(event, "BIPT_" + item?.id)}
                variant="outlined"
                className={
                  errors["BIPT_" + item?.id]
                    ? "border border-danger form-control text-center "
                    : "form-control text-center "
                }
                placeholder="00:00"
              />
            )}
          />
        </Col>
      </Col>
    </>
  );
}

export default MobileViewOfWaranty;
